import React, { Component } from 'react'
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { FaSearch } from "react-icons/fa";
import { MdHelp, MdDelete } from "react-icons/md";
import { Card, Col, Row, Table, Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import ListTicketRowComponent from '../../../components/Admin/tickets/ListTicketRowComponent';
import PaginateComponent from  '../../../components/PaginateComponent';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

class AdminTicketPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			listTicket: [],
			perPage: 0,
			totalPage: 0,
			currentPage: 0,
			error: false,
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			checkedTicketIds: [],
			rq_table: {
                per_page: 10,
                page: 0,
                s: '',
                order_by: 'id',
                order: 'desc',
            },
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getListTicket();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getListTicket = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: this.state.rq_table
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/ticket', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					listTicket: ref.data.content.data,
					rq_table: ref.data.content.filters,
					perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
				});
				this.state.listTicket.forEach( ticket => {
					ticket.checked = false;
		        });
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

    listTicketRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listTicket.length ) {
                return (
                    this.state.listTicket.map( (ticket, key) => {
                        return (
                            <ListTicketRowComponent
	                            key={key}
	                            ticket={ticket}
	                            actionKey={key}
	                            delete={ (id) => this.deleteTicketConFirm(id) }
	                            checkedTicket = { (actionKey) => this.checkedTicket(actionKey) }
                                checkedTicketShiftKey = { (actionKey, value) => this.checkedTicketShiftKey(actionKey, value) }
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

	checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	sort = (order_by) => {
		this.setState(
			{
				rq_table: {
			        ...this.state.rq_table, 
					order_by: order_by, 
					order: this.state.rq_table.order === 'desc' ? 'asc' : 'desc'
			    }
			},
			() => this.getListTicket()
		)
	}	

	change = (e) => {
		this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value,
					page: 0
			    }
			},
			() => this.getListTicket()
		)
	}

    search = (e) => {
	    this.setState(
	    	{
		    	rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value
			    }
		    }
	    )
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
        	this.setState(
				{
					currentPage: 0,
					rq_table: {
				        ...this.state.rq_table,
						page: 0
				    }
				},
				() => this.getListTicket()
			)
        }
    }

    btnSearch = () => {
        this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table,
					page: 0
			    }
			},
			() => this.getListTicket()
		)
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
		this.setState(
			{
				currentPage: page,
				rq_table: {
			        ...this.state.rq_table, 
					page: page
			    }
			},
			() => this.getListTicket()
		)
    }

    checkAll = (e) => {
        let value = e.target.checked;
        let listTicket = this.state.listTicket;
        listTicket.forEach( ticket => {
            ticket.checked = value;
        });
        this.setState({
            checkAll: value,
            listTicket: listTicket
        });
        this.checkedTicketIds(listTicket);
    }

    checkedTicket  = (actionKey) => {
        let listTicket = this.state.listTicket;
        listTicket[actionKey].checked = !listTicket[actionKey].checked;
        this.setState({
            listTicket: listTicket,
            checkedStart: actionKey
        });
        this.checkedTicketIds(listTicket);
    }

    checkedTicketShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listTicket = this.state.listTicket;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listTicket[i].checked = value;
            }
            this.setState({
                listTicket: listTicket,
                checkedStart: k
            });
            this.checkedTicketIds(listTicket);
        } else {
            let listTicket = this.state.listTicket;
            listTicket[actionKey].checked = !listTicket[actionKey].checked;
            this.setState({
                listTicket: listTicket,
                checkedStart: actionKey
            });
            this.checkedTicketIds(listTicket);
        }
    }

    checkedTicketIds = (listTicket) => {
    	let checkedTicketIds = [];
    	listTicket.forEach( ticket => {
    		if (ticket.checked) {
    			checkedTicketIds.push(ticket.id)
    		}
        });
        this.setState({
        	checkedTicketIds: checkedTicketIds
        },
        () => console.log(this.state.checkedTicketIds)
        )
    }

	deleteTicketConFirm = (id) => {
		confirmAlert({
	      	title: '',
	      	message: 'Bạn muốn xóa ticket này?',
	      	buttons: [
		        {
		          	label: 'Xác nhận',
		          	onClick: () => {
		          		this.deleteTicketRequest(id);
		          	}
		        },
		        {
		          	label: 'Hủy',
		          	onClick: () => false
		        }
	      	]
	    });
	}

	deleteTicketRequest = (id) => {
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: {id: id}
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/ticket/delete', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
				},
				() => this.getListTicket()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

    deleteTickets = () => {
    	if (this.state.checkedTicketIds.length) {
    		confirmAlert({
		      	title: '',
		      	message: 'Bạn muốn xóa các ticket này?',
		      	buttons: [
			        {
			          	label: 'Xác nhận',
			          	onClick: () => { this.deleteTicketsRequest() }
			        },
			        {
			          	label: 'Hủy',
			          	onClick: () => false
			        }
		      	]
		    });
    	} else {
    		confirmAlert({
		      	title: '',
		      	message: 'Bạn chưa chọn mục cần xóa?',
		      	buttons: [
			        {
			          	label: 'OK',
			          	onClick: () => false
			        }
		      	]
		    });
    	}
    }

    deleteTicketsRequest = () => {

    	let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: {ids: this.state.checkedTicketIds}
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/ticket/multi-delete', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
				checkedTicketIds: []
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					checkedTicketIds: [],
				},
				() => this.getListTicket()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
    }

	render() {
		return (
			<>
                <Breadcrumb title={"Ticket"} page={"Ticket"} icon={<MdHelp className="breadcrumb-icon" />} />

                <Row style={{ marginTop: 20 }}>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}
					</Col>
				</Row>

                <Card body>
                	<Row>
                		<Col md={12} className="d-md-flex mb-0">
                			<select className="form-control select2 form-control-sm m-1" name='per_page' onChange={ this.change } id="per_page" defaultValue={this.state.rq_table.per_page} style={{ width:'75px' }}>
			                    <option value="10">10</option>
			                    <option value="20">20</option>
			                    <option value="50">50</option>
			                    <option value="100">100</option>
			                </select>
			                <label className="per_page ml-2 mt-2" htmlFor="per_page">Hiển thị mỗi trang</label>
                		</Col>
                		<Col md={12} className="mb-3">
                			<div className="float-md-left d-sm-flex">
                				<button
									className={`btn btn-${this.state.checkedTicketIds.length ? 'danger' : 'outline-danger'} btn-sm m-1`}
									onClick={ () => this.deleteTickets() }
								>
									<MdDelete /> Xóa ticket
								</button>
                			</div>
                			<div className="float-md-right d-sm-flex">
                				<div className="form-group m-1">
		                            <div className="input-group">
		                                <input type="text" name="s" className="form-control form-control-sm"
		                                       placeholder="tiêu đề, nội dung" id="search"
		                                       onChange={ this.search }
		                                       onKeyPress={ this.submitSearch }
		                                />
	                                    <div className="input-group-append">
	                                        <button type="button" className="btn btn-sm btn-danger" onClick={ () => this.btnSearch() }>
	                                            <FaSearch  />
	                                        </button>
	                                    </div>
		                            </div>
		                        </div>
                			</div>
                		</Col>
                		<Col sm={12} className="table-responsive">
		                    <Table className="table table-sm table-bordered table-hover rounded">
		                        <thead className="primary">
		                            <tr>
		                            	<th className="text-center" width="3%">
		                            		<input
									          	type="checkbox"
									          	defaultValue={false}
									          	onChange={ this.checkAll }
									        />
		                            	</th>
		                                <th>Mã ticket</th>
		                                <th>User</th>
		                                <th>Tiêu đề</th>
		                                <th>Nội dung</th>
		                                <th>Trạng thái</th>
		                                <th
		                                	onClick={ () => this.sort('created_at') } 
		                                	className={`text-center sorting ${this.state.rq_table.order_by === "created_at"? 'order_by': ''} 
		                                		${this.state.rq_table.order_by === "created_at" && this.state.rq_table.order === "desc" ? 'sorting_desc': ''}
		                                		${this.state.rq_table.order_by === "created_at" && this.state.rq_table.order === "asc" ? 'sorting_asc': ''}
		                            		`}
		                                >
		                                	Ngày tạo
		                                </th>
		                                <th>Action</th>
		                            </tr>
		                        </thead>
		                        <tbody>
		                            { this.listTicketRow() } 
		                        </tbody>
		                    </Table>
		                    { this.paginate() }
		                </Col>
                	</Row>

                </Card>
            </>	
		)
	}
}


const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminTicket' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTicketPage);